// @flow
import { MediosActionTypes } from './constants';

type MediosAction = { type: string, payload: {} | string };

// common success
export const mediosApiResponseSuccess = (actionType: string, data: any): MediosAction => ({
    type: MediosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const mediosApiResponseError = (actionType: string, error: string): MediosAction => ({
    type: MediosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getMedio = (id: string): MediosAction => ({
    type: MediosActionTypes.GET_MEDIO,
    payload: { id },
});

export const addMedio = (medio:any):MediosAction=>({
    type:MediosActionTypes.ADD_MEDIO,
    payload:medio
})
export const updateMedio = (medio:any):MediosAction=>({
    type:MediosActionTypes.UPDATE_MEDIO,
    payload:medio
})
export const deleteMedio = (id:string):MediosAction=>({
    type:MediosActionTypes.DELETE_MEDIO,
    payload:{id}
})

export const listMedios = (params:any): MediosAction => ({
    type: MediosActionTypes.LIST_MEDIOS,
    payload: params,
});

export const setFiltersMedios = (params:any): MediosAction => ({
    type: MediosActionTypes.SET_FILTER,
    payload: params,
})

export const resetMedios = (): MediosAction => ({
    type: MediosActionTypes.RESET,
    payload: {},
});

